import { StrictMode } from "react";
import { render } from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider } from "styled-components";
import App from "./App";
import store from "./redux/store";
import theme from "./theme";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import GlobalStyles from "./GlobalStyles";
import { localizations, getLanguage } from "./components/localization";

YaGames.init().then(function (ysdk) {
  window.ysdk = ysdk;
  window.addEventListener("focus", function (e) {
    window.ysdk.features.GameplayAPI.start();
  });

  window.addEventListener("blur", function (e) {
    window.ysdk.features.GameplayAPI.stop();
  });

  window.ysdk.features.LoadingAPI.ready();
  window.addEventListener("contextmenu", function (e) {
    e.preventDefault();
  });
  window.addEventListener("doubleclick", function (e) {
    e.preventDefault();
  });
  window.ysdk.features.GameplayAPI.stop();
  window.ysdk.adv.showFullscreenAdv({
    callbacks: {
      onClose: function (wasShown) {
        window.ysdk.features.GameplayAPI.start();
        document.querySelector("#title").textContent =
          localizations.name[getLanguage()];
        render(
          <StrictMode>
            <ReduxProvider store={store}>
              <ThemeProvider theme={theme}>
                <GlobalStyles />
                <App />
              </ThemeProvider>
            </ReduxProvider>
          </StrictMode>,
          document.getElementById("root")
        );
      },
      onError: function (error) {},
    },
  });
});
